import { CardContent, CardActions, Box } from '@mui/material'
import { forwardRef } from 'react'
import { CustomPaper } from './CustomPaper'
import { TitleSection } from './TitleSection'
import { merge } from 'lodash'

export const Card = forwardRef(
  (
    {
      title = '',
      subTitle = '',
      titleVariant = 'textPrimary',
      subTitleVariant = 'textSecondary',
      titleProps = {},
      actions,
      content,
      sx = {},
      paperProps = {},
      children,
      ...rest
    },
    outerRef
  ) => {
    return (
      <Box
        sx={merge(
          {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          },
          sx || {}
        )}
        {...rest}
      >
        {title && (
          <TitleSection
            title={title}
            titleVariant={titleVariant}
            subTitle={subTitle}
            subTitleVariant={subTitleVariant}
            {...titleProps}
          />
        )}
        <CustomPaper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '10px',
            p: 0,
          }}
          {...paperProps}
        >
          <CardContent>{children}</CardContent>
          {actions && <CardActions>{actions}</CardActions>}
        </CustomPaper>
      </Box>
    )
  }
)
